import { UntypedFormGroup } from '@angular/forms';

import { FormlyFieldConfig } from '@ngx-formly/core';

import { DatasheetGroup } from '../models/datasheet.model';

export class DatasheetFormlyUtils {
  static getSectionTables(groups: DatasheetGroup[]): FormlyFieldConfig[] {
    const allFormFields: FormlyFieldConfig[] = [];
    groups.forEach(group => {
      group.sections.forEach(section => {
        allFormFields.push(
          ...section.tables.map(table => {
            return {
              ...table,
              templateOptions: {
                ...table.templateOptions,
                groupId: group.id,
                sectionId: section.id,
              },
            };
          })
        );
      });
    });
    return allFormFields;
  }
  static getEditablePerformanceKeys(groups: DatasheetGroup[]): string[] {
    const keys: string[] = [];
    const tables = this.getSectionTables(groups);
    
    tables.forEach(table => {
      table.fieldGroup?.forEach(field => {
        if (field.props?.editable && field.key) {
          keys.push(field.key as string);
        }
      });
    });
    return keys;
  }

  static getEditableWorkingConditionsKeys(groups: DatasheetGroup[]): string[] {
    const keys: string[] = [];
    const tables = this.getSectionTables(groups);

    const traverseFieldGroup = (fieldGroup: any[] | undefined): void => {
      if (!fieldGroup || fieldGroup.length === 0) {
        return;
      }

      fieldGroup.forEach(field => {
        if (field.key) {
          keys.push(field.key);
        }

        if (field.fieldGroup) {
          traverseFieldGroup(field.fieldGroup);
        }
      });
    };

    tables.forEach(table => {
      const workingConditionFields = table.fieldGroup?.filter(field =>
        field.wrappers?.includes('working-condition')
      );

      workingConditionFields?.forEach(field => {
        if (field.fieldGroup) {
          traverseFieldGroup(field.fieldGroup);
        }
      });
    });

    return keys;
  }

  static computeEditablePerformanceValues(
    form: UntypedFormGroup | undefined,
    userEditedValues: Record<string, unknown>,
    keys: string[]
  ): any {
    const editedValues = {};
    keys.forEach(key => {
      let editedValue = userEditedValues[key] as Record<string, unknown>;

      if (!editedValue) {
        const formValue: any = Object.values(form?.getRawValue() ?? {}).find((objValue: any) => objValue[key]);
        editedValue = formValue ? formValue[key] : null;
      }

      if (editedValue) {
        Object.entries(editedValue).forEach(([controlKey, controlValue]: [string, any]) => {
          if (typeof controlValue === 'object') {
            editedValues[controlKey] = Object.values(controlValue).join('\t');
          } else {
            editedValues[controlKey] = controlValue;
          }
        });
      }
    });
    return editedValues;
  }

  static computeEditableWorkingConditionsValues(
    form: UntypedFormGroup | undefined,
    userEditedValues: Record<string, unknown>,
    keys: string[]
  ): any {
    const workingConditions = {};
    keys.forEach(key => {
      let editedValue = userEditedValues[key] as Record<string, unknown>;

      if (!editedValue) {
        const formValue: any = Object.values(form?.getRawValue() ?? {}).find((objValue: any) => objValue[key]);
        editedValue = formValue ? formValue[key] : null;
      }

      if (editedValue) {
        workingConditions[key] = editedValue;
      }
    });
    return workingConditions;
  }
}
